import { Outlet, useLocation } from "react-router-dom";
import ManagedSitesSection from "@/components/managed-sites-section";
import { PageContainer } from "@/components/page-container";

export default function SiteIndex() {
  const { pathname } = useLocation();

  if (pathname === "/sites") {
    return (
      <PageContainer className="flex min-h-full flex-col">
        <ManagedSitesSection />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Outlet />
    </PageContainer>
  );
}
